// ABOUTME: The Crossing theme -- composed over naluV1Theme, applied by a local ThemeProvider inside
// ABOUTME: CrossingRunnerFrame only (not family-selectable, not in themeRegistry.ts, per ADR #14) (Issue #1940).

import type { CSSProperties } from 'react';
import '@fontsource/nunito-sans/800.css'; // nalu-v1 only imports through 700; 800 is the prototype's dominant UI weight
import { createTheme } from '@mui/material/styles';
import { naluV1Theme } from './theme.nalu-v1';
import {
  CROSSING_GROUND, CROSSING_HAIRLINE, CROSSING_TEAL_EYEBROW,
  CROSSING_BUTTON_FILL, CROSSING_BUTTON_FILL_HOVER, CROSSING_BUTTON_TEXT,
} from './crossingTokens';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    crossingEyebrow: CSSProperties;
    crossingHeadline: CSSProperties;
    crossingQuote: CSSProperties;
  }
  interface TypographyVariantsOptions {
    crossingEyebrow?: CSSProperties;
    crossingHeadline?: CSSProperties;
    crossingQuote?: CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    crossingEyebrow: true;
    crossingHeadline: true;
    crossingQuote: true;
  }
}

export const crossingTheme = createTheme(naluV1Theme, {
  palette: {
    background: {
      default: CROSSING_GROUND,
      paper: CROSSING_GROUND,
    },
  },
  typography: {
    crossingEyebrow: {
      fontFamily: '"Nunito Sans", sans-serif',
      fontSize: '10.5px',
      fontWeight: 800,
      letterSpacing: '0.05em',
      color: CROSSING_TEAL_EYEBROW,
    },
    crossingHeadline: {
      fontFamily: '"Newsreader", serif',
      fontSize: '22px',
      fontWeight: 600,
    },
    crossingQuote: {
      fontFamily: '"Newsreader", serif',
      fontStyle: 'italic',
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // Rung-2 crossing variant: a stock nalu button renders black-on-teal, which fails inside
        // Crossing's own palette -- filled buttons use the darker AA-mitigated teal.
        contained: { backgroundColor: CROSSING_BUTTON_FILL, color: CROSSING_BUTTON_TEXT, '&:hover': { backgroundColor: CROSSING_BUTTON_FILL_HOVER } },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 999 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundColor: CROSSING_GROUND, border: `1px solid ${CROSSING_HAIRLINE}` },
      },
    },
  },
});

export default crossingTheme;
